import React from 'react'
import { Button, Modal, Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch, connect } from 'react-redux'
import { thunks as AuthThunks } from 'reducers/Auth'
import ModalActions from 'reducers/Modal'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import {
  XButtonWrapper,
  ButtonWrapper
} from '../SignoutModal/SignoutModal.styles'
import { Close } from '@dsny/dsny-component-library/icons'
import { StyledModal } from '../Modals.styles'
import { trackEvent } from 'utils/segmentService'

const mapStateToProps = ({ modal }) => ({
  showSignoutAllSessionsModal: modal?.showSignoutAllSessionsModal
})

function SignoutAllSessionsModal({ showSignoutAllSessionsModal }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()

  const handleCancelButtonClick = () => {
    dispatch(ModalActions.toggleSignoutAllSessionsModal())
  }

  const cancelAllSessions = async () => {
    dispatch(ModalActions.toggleSignoutAllSessionsModal())

    try {
      await dispatch(dispatch(AuthThunks.cancelAllSessions()))
    } catch (error) {
      console.error(error?.data)
    }
  }

  return (
    <StyledModal
      $isMobile={isMobile}
      isOpen={showSignoutAllSessionsModal}
      onClose={handleCancelButtonClick}
      analyticsModalType="signout_all_sessions"
      trackEvent={trackEvent}
      containerStyles={{
        padding: isMobile ? '24px 12px' : '72px 64px 40px'
      }}
    >
      <XButtonWrapper onClick={handleCancelButtonClick}>
        <Close width={24} height={24} color={theme.colors.neutralW80} />
      </XButtonWrapper>

      <Tonality.UIHeading
        headingStyle="headline5"
        color={theme.colors.neutralW90}
        style={{ lineHeight: 2 }}
      >
        {t('settings.signout-all-sessions-modal-title')}
      </Tonality.UIHeading>

      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW70}
        style={{ fontSize: 14, marginBottom: 32 }}
      >
        {t('settings.signout-all-sessions-modal-body')}
      </Tonality.UIText>

      <ButtonWrapper style={{ gap: 16 }}>
        <Button
          variant="primary"
          setting="player"
          mode="dark"
          onClick={cancelAllSessions}
        >
          {t('settings.signout-everywhere')}
        </Button>

        <Button
          variant="secondary"
          setting="player"
          mode="dark"
          onClick={handleCancelButtonClick}
        >
          {t('general.cancel')}
        </Button>
      </ButtonWrapper>
    </StyledModal>
  )
}

export default connect(mapStateToProps)(SignoutAllSessionsModal)
